/* eslint-disable */
export enum BenefitCategory {
  MEAL = "meal",
  TRANSPORT = "transport",
  NURSERY = "nursery",
  TRAINING = "training",
  DISCOUNT = "discount",
  GYM = "gym",
  IT_PRODUCT = "it-product",
  GROCERIES = "groceries",
  GAS = "gas",
  PENSION_PLAN = "pension-plan",
  RENTING = 'renting',
  RETIREMENT_INSURANCE = "retirement-insurance",
  LIFE_INSURANCE = "life-insurance",
  CUSTOM = "custom",
  HEALTH_INSURANCE = "health-insurance",
}
